// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Dict from "@rescript/core/src/Core__Dict.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as PaymentBody$OrcaPaymentPage from "../Utilities/PaymentBody.bs.js";
import * as SessionsType$OrcaPaymentPage from "../Types/SessionsType.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "../Utilities/PaymentHelpers.bs.js";
import * as ClickToPayHelpers$OrcaPaymentPage from "../Types/ClickToPayHelpers.bs.js";

var clickToPayTokenCache = {};

function setClickToPayTokenWithDebounce(key, promise) {
  clickToPayTokenCache[key] = promise;
  setTimeout((function () {
          if (Core__Option.isSome(clickToPayTokenCache[key])) {
            return Core__Dict.$$delete(clickToPayTokenCache, key);
          }
          
        }), 30000);
}

async function initClickToPaySession(clientSecret, publishableKey, logger, customPodUri, endpoint, profileId, authenticationId, merchantId, initClickToPaySessionInput, shouldLoadScriptsOpt) {
  var shouldLoadScripts = shouldLoadScriptsOpt !== undefined ? shouldLoadScriptsOpt : true;
  var customerEmail = {
    contents: ""
  };
  var maskedCards = {
    contents: []
  };
  var key = clientSecret + "_" + authenticationId;
  var handleApi = function () {
    return PaymentHelpers$OrcaPaymentPage.fetchEnabledAuthnMethodsToken(clientSecret, publishableKey, logger, customPodUri, endpoint, false, profileId, authenticationId);
  };
  var tmp;
  if (shouldLoadScripts) {
    tmp = handleApi();
  } else {
    var promise = clickToPayTokenCache[key];
    if (promise !== undefined) {
      tmp = Caml_option.valFromOption(promise);
    } else {
      var promise$1 = handleApi();
      setClickToPayTokenWithDebounce(key, promise$1);
      tmp = promise$1;
    }
  }
  var data = await tmp;
  var getClickToPayToken = function (ssn) {
    var dict = Utils$OrcaPaymentPage.getDictFromJson(ssn);
    var clickToPaySessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "ClickToPayObject");
    var match = SessionsType$OrcaPaymentPage.getPaymentSessionObj(clickToPaySessionObj.sessionsToken, "ClickToPay");
    if (match.TAG !== "ClickToPayTokenOptional") {
      return ;
    }
    var token = match._0;
    if (token !== undefined) {
      return ClickToPayHelpers$OrcaPaymentPage.clickToPayTokenItemToObjMapper(token);
    }
    
  };
  var ctpToken = getClickToPayToken(data);
  var getMaskedCardsListFromResponse = function (authenticationResponse) {
    return Core__Option.getOr(Core__Option.flatMap(authenticationResponse.profiles, (function (profiles) {
                        return profiles.flatMap(function (profile) {
                                    return profile.maskedCards;
                                  });
                      })), []).map(function (card) {
                return {
                        srcDigitalCardId: card.srcDigitalCardId,
                        panLastFour: card.panLastFour,
                        panExpirationMonth: card.panExpirationMonth,
                        panExpirationYear: card.panExpirationYear,
                        paymentCardDescriptor: card.paymentCardDescriptor.toUpperCase(),
                        digitalCardData: card.digitalCardData,
                        panBin: card.panBin
                      };
              });
  };
  var getClickToPayErrorResponse = function (error, defaultErrorTypeOpt, defaultErrorMessage) {
    var defaultErrorType = defaultErrorTypeOpt !== undefined ? defaultErrorTypeOpt : "ERROR";
    if (error === undefined) {
      return Utils$OrcaPaymentPage.getFailedSubmitResponse(defaultErrorType, defaultErrorMessage);
    }
    var errorType = Core__Option.getOr(error.reason, defaultErrorType);
    var getCardsErrorMessage = Core__Option.getOr(error.message, "");
    var errorMessage = getCardsErrorMessage.trim().length > 0 ? getCardsErrorMessage : defaultErrorMessage;
    return Utils$OrcaPaymentPage.getFailedSubmitResponse(errorType, errorMessage);
  };
  var isCustomerPresent = async function (visaDirectSdk, email) {
    logger.setLogInfo("CUSTOMER_CHECK | STARTED", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    if (email !== undefined) {
      customerEmail.contents = email;
    } else {
      logger.setLogInfo("CUSTOMER_CHECK | No email is passed directly to isCustomerPresent method.", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    }
    var consumerIdentity_identityProvider = "SRC";
    var consumerIdentity_identityValue = customerEmail.contents;
    var consumerIdentity = {
      identityProvider: consumerIdentity_identityProvider,
      identityType: "EMAIL_ADDRESS",
      identityValue: consumerIdentity_identityValue
    };
    var isCustomerPresentForMastercard = false;
    var isCustomerPresentForVisa = false;
    var clickToPayData = [];
    var mastercardDirectIdentityLookupPromise = window.SRCSDK_MASTERCARD.identityLookup({
          consumerIdentity: consumerIdentity
        });
    var visaDirectIdentityLookupPromise = visaDirectSdk !== undefined ? visaDirectSdk.identityLookup(consumerIdentity) : Promise.resolve(null);
    var identityLookupPromiseResults = await Promise.allSettled([
          mastercardDirectIdentityLookupPromise,
          visaDirectIdentityLookupPromise
        ]);
    if (identityLookupPromiseResults.length === 2) {
      var mastercardDirectIdentityLookup = identityLookupPromiseResults[0];
      var visaDirectIdentityLookup = identityLookupPromiseResults[1];
      if (mastercardDirectIdentityLookup.status === "fulfilled") {
        var value = mastercardDirectIdentityLookup.value;
        var present = Utils$OrcaPaymentPage.getBool(Utils$OrcaPaymentPage.getDictFromJson(value), "consumerPresent", false);
        isCustomerPresentForMastercard = present;
        logger.setLogInfo("CUSTOMER_CHECK | MASTERCARD | Customer: " + (
              present ? "present" : "not present"
            ), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
        clickToPayData.push([
              "mastercard",
              value
            ]);
      } else {
        logger.setLogError("CUSTOMER_CHECK | MASTERCARD | Direct Mastercard Click to Pay identityLookup failed " + JSON.stringify(Utils$OrcaPaymentPage.formatException(mastercardDirectIdentityLookup.reason)), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
      }
      if (visaDirectIdentityLookup.status === "fulfilled") {
        var value$1 = visaDirectIdentityLookup.value;
        var present$1 = Utils$OrcaPaymentPage.getBool(Utils$OrcaPaymentPage.getDictFromJson(value$1), "consumerPresent", false);
        isCustomerPresentForVisa = present$1;
        logger.setLogInfo("CUSTOMER_CHECK | VISA | Customer: " + (
              present$1 ? "present" : "not present"
            ), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
        clickToPayData.push([
              "visa",
              value$1
            ]);
      } else {
        logger.setLogError("CUSTOMER_CHECK | VISA | Direct Visa Click to Pay identityLookup failed " + JSON.stringify(Utils$OrcaPaymentPage.formatException(visaDirectIdentityLookup.reason)), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
      }
    }
    var eligibilityCheckData = [[
        "click_to_pay",
        Utils$OrcaPaymentPage.getJsonFromArrayOfJson(clickToPayData)
      ]];
    var eligibilityCheckBodyArr = [[
        "eligibility_check_data",
        Utils$OrcaPaymentPage.getJsonFromArrayOfJson(eligibilityCheckData)
      ]];
    await PaymentHelpers$OrcaPaymentPage.fetchEligibilityCheck(clientSecret, publishableKey, logger, customPodUri, endpoint, false, profileId, authenticationId, eligibilityCheckBodyArr);
    var isC2pProfilePresent = isCustomerPresentForMastercard || isCustomerPresentForVisa;
    logger.setLogInfo("CUSTOMER_CHECK | COMPLETED | Customer " + (
          isC2pProfilePresent ? "present" : "not present"
        ), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    return Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
                  "customerPresent",
                  isC2pProfilePresent
                ]]);
  };
  var getUserType = async function () {
    var getCardsConfig_consumerIdentity = {
      identityProvider: "SRC",
      identityType: "EMAIL_ADDRESS",
      identityValue: customerEmail.contents
    };
    var getCardsConfig = {
      consumerIdentity: getCardsConfig_consumerIdentity
    };
    var getUserTypeErrorMessage = "An unknown error occurred while fetching user type.";
    logger.setLogInfo("GET_USER_TYPE | INIT | Checking for user type", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    try {
      var getCardsResponse = await window.VSDK.getCards(getCardsConfig);
      var match = getCardsResponse.actionCode;
      var statusCode;
      var exit = 0;
      switch (match) {
        case "SUCCESS" :
            maskedCards.contents = getMaskedCardsListFromResponse(getCardsResponse);
            var areMaskedCardsPresent = maskedCards.contents.length > 0;
            if (areMaskedCardsPresent) {
              var visaCount = maskedCards.contents.filter(function (card) {
                    return card.paymentCardDescriptor.toLowerCase().includes("visa");
                  }).length;
              var mastercardCount = maskedCards.contents.filter(function (card) {
                    return card.paymentCardDescriptor.toLowerCase().includes("mastercard");
                  }).length;
              logger.setLogInfo("GET_USER_TYPE | SUCCESS | visa: " + visaCount.toString() + " | mastercard: " + mastercardCount.toString(), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
              statusCode = "RECOGNIZED_CARDS_PRESENT";
            } else {
              logger.setLogInfo("GET_USER_TYPE | NO_RECOGNIZED_CARDS | Successfully Called getCards but no recognized cards are present for the customer.", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
              statusCode = "NO_CARDS_PRESENT";
            }
            break;
        case "PENDING_CONSUMER_IDV" :
            logger.setLogInfo("GET_USER_TYPE | PENDING_AUTH | User requires authentication", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
            statusCode = "TRIGGERED_CUSTOMER_AUTHENTICATION";
            break;
        case "FAILED" :
        case "ERROR" :
            exit = 1;
            break;
        case "ADD_CARD" :
            logger.setLogInfo("GET_USER_TYPE | NO_CARDS | No recognized cards are present for the customer.", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
            statusCode = "NO_CARDS_PRESENT";
            break;
        
      }
      if (exit === 1) {
        logger.setLogError("GET_USER_TYPE | actionCode: " + ClickToPayHelpers$OrcaPaymentPage.getStrFromActionCode(getCardsResponse.actionCode) + " | reason : " + Core__Option.getOr(Core__Option.flatMap(getCardsResponse.error, (function (err) {
                        return err.reason;
                      })), "UNKNOWN_ERROR"), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
        statusCode = "ERROR";
      }
      if (statusCode !== "ERROR") {
        return Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
                      "statusCode",
                      statusCode
                    ]]);
      } else {
        return getClickToPayErrorResponse(getCardsResponse.error, undefined, getUserTypeErrorMessage);
      }
    }
    catch (raw_err){
      var err = Caml_js_exceptions.internalToOCamlException(raw_err);
      logger.setLogError("Get Cards failed " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err)), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
      return Utils$OrcaPaymentPage.getFailedSubmitResponse("ERROR", getUserTypeErrorMessage);
    }
  };
  var getRecognizedCards = async function () {
    logger.setLogInfo("Fetching recognized cards for the customer.", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    return maskedCards.contents;
  };
  var validateCustomerAuthentication = async function (otpValue) {
    var value = otpValue.value;
    var getCardsConfig_consumerIdentity = {
      identityProvider: "SRC",
      identityType: "EMAIL_ADDRESS",
      identityValue: customerEmail.contents
    };
    var getCardsConfig_validationData = value;
    var getCardsConfig = {
      consumerIdentity: getCardsConfig_consumerIdentity,
      validationData: getCardsConfig_validationData
    };
    var validateCustomerAuthenticationErrorMessage = "An unknown error occurred during customer authentication validation.";
    try {
      var validateCustomerAuthenticationResponse = await window.VSDK.getCards(getCardsConfig);
      var match = validateCustomerAuthenticationResponse.actionCode;
      if (match === "SUCCESS") {
        maskedCards.contents = getMaskedCardsListFromResponse(validateCustomerAuthenticationResponse);
        var visaCount = maskedCards.contents.filter(function (card) {
              return card.paymentCardDescriptor.toLowerCase().includes("visa");
            }).length;
        var mastercardCount = maskedCards.contents.filter(function (card) {
              return card.paymentCardDescriptor.toLowerCase().includes("mastercard");
            }).length;
        logger.setLogInfo("AUTH_VALIDATION | SUCCESS | visa : " + visaCount.toString() + " | mastercard : " + mastercardCount.toString(), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
        return maskedCards.contents;
      }
      logger.setLogError("AUTH_VALIDATION | Validate Customer Authentication returned error action code " + ClickToPayHelpers$OrcaPaymentPage.getStrFromActionCode(validateCustomerAuthenticationResponse.actionCode) + " | reason : " + Core__Option.getOr(Core__Option.flatMap(validateCustomerAuthenticationResponse.error, (function (err) {
                      return err.reason;
                    })), "UNKNOWN_ERROR"), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
      return getClickToPayErrorResponse(validateCustomerAuthenticationResponse.error, undefined, validateCustomerAuthenticationErrorMessage);
    }
    catch (raw_err){
      var err = Caml_js_exceptions.internalToOCamlException(raw_err);
      logger.setLogError("AUTH_VALIDATION | Validate Customer Authentication failed " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err)), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
      return Utils$OrcaPaymentPage.getFailedSubmitResponse("ERROR", validateCustomerAuthenticationErrorMessage);
    }
  };
  var checkoutWithCard = async function (token, srcDigitalCardId, rememberMe, windowRef) {
    logger.setLogInfo("CHECKOUT | INIT | RememberMe: " + (
          Core__Option.getOr(rememberMe, false) ? "true" : "false"
        ), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    var checkoutWithCardErrorMessage = "An unknown error occurred during checkout with card.";
    try {
      var clickToPayWindow = (windowRef == null) ? (logger.setLogInfo("CHECKOUT | No window reference provided. Opening new window for Click to Pay checkout flow.", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined), Core__Option.isNone(Caml_option.nullable_to_opt(ClickToPayHelpers$OrcaPaymentPage.clickToPayWindowRef.contents)) ? ClickToPayHelpers$OrcaPaymentPage.handleOpenClickToPayWindow() : undefined, Caml_option.nullable_to_opt(ClickToPayHelpers$OrcaPaymentPage.clickToPayWindowRef.contents)) : (logger.setLogInfo("CHECKOUT | Using provided window reference for Click to Pay checkout flow.", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined), Caml_option.some(windowRef));
      if (clickToPayWindow !== undefined) {
        var consumer_fullName = "";
        var consumer_emailAddress = customerEmail.contents;
        var consumer_mobileNumber = {
          phoneNumber: "",
          countryCode: ""
        };
        var consumer = {
          fullName: consumer_fullName,
          emailAddress: consumer_emailAddress,
          mobileNumber: consumer_mobileNumber
        };
        var checkoutWithCardResponse = await ClickToPayHelpers$OrcaPaymentPage.checkoutVisaUnified(srcDigitalCardId, undefined, Caml_option.valFromOption(clickToPayWindow), undefined, Core__Option.getOr(rememberMe, false), token, clientSecret, consumer, Core__Option.getOr(initClickToPaySessionInput.request3DSAuthentication, true));
        ClickToPayHelpers$OrcaPaymentPage.handleCloseClickToPayWindow();
        var actionCode = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(checkoutWithCardResponse), "actionCode", "");
        if (actionCode === "SUCCESS") {
          logger.setLogInfo(Core__Option.getOr(JSON.stringify({
                        message: "CHECKOUT | Checkout successful",
                        scheme: "VISA"
                      }), "Failed to stringify successful checkout message"), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
          var dict = Utils$OrcaPaymentPage.getDictFromJson(checkoutWithCardResponse);
          var visaClickToPayBodyArr = PaymentBody$OrcaPaymentPage.visaClickToPayAuthenticationBody(Utils$OrcaPaymentPage.getString(dict, "checkoutResponse", ""));
          var authenticationSyncResponse = await PaymentHelpers$OrcaPaymentPage.fetchAuthenticationSync(clientSecret, publishableKey, logger, customPodUri, endpoint, false, profileId, authenticationId, merchantId, visaClickToPayBodyArr);
          window.initializedVSDK = false;
          window.visaDirectSdk = null;
          return Utils$OrcaPaymentPage.transformKeysWithoutModifyingValue(authenticationSyncResponse, "CamelCase");
        }
        var errorReason = actionCode === "ERROR" ? Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromJson(checkoutWithCardResponse), "error"), "reason", "UNKNOWN_ERROR") : "";
        logger.setLogError(Core__Option.getOr(JSON.stringify({
                      message: "CHECKOUT | FAILED | code: " + actionCode + " " + (
                        errorReason !== "" ? "| reason: " + errorReason : ""
                      ),
                      scheme: "VISA"
                    }), "Failed to stringify failed checkout message"), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
        var errorMsg;
        switch (actionCode) {
          case "CHANGE_CARD" :
              errorMsg = "Consumer wishes to select an alternative card.";
              break;
          case "SWITCH_CONSUMER" :
              errorMsg = "Consumer wishes to change Click to Pay profile.";
              break;
          default:
            errorMsg = checkoutWithCardErrorMessage;
        }
        if (actionCode !== "CHANGE_CARD" && actionCode !== "SWITCH_CONSUMER") {
          window.initializedVSDK = false;
          window.visaDirectSdk = null;
        }
        return Utils$OrcaPaymentPage.getFailedSubmitResponse(actionCode, errorMsg);
      }
      logger.setLogError("CHECKOUT | Error trying to open window for Click to Pay checkout flow.", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
      return Utils$OrcaPaymentPage.getFailedSubmitResponse("ERROR", checkoutWithCardErrorMessage);
    }
    catch (raw_err){
      var err = Caml_js_exceptions.internalToOCamlException(raw_err);
      logger.setLogError("CHECKOUT | Checkout with Card failed " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err)), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
      ClickToPayHelpers$OrcaPaymentPage.handleCloseClickToPayWindow();
      return Utils$OrcaPaymentPage.getFailedSubmitResponse("ERROR", checkoutWithCardErrorMessage);
    }
  };
  var signOut = async function () {
    var unbindAppInstanceErrorMessage = "Failed to sign out customer.";
    try {
      var unbindAppInstanceResponse = await window.VSDK.unbindAppInstance();
      var err = unbindAppInstanceResponse.error;
      if (err !== undefined) {
        logger.setLogError("SIGNOUT | Failed to sign out Customer " + Core__Option.getOr(err.reason, "Unknown Error"), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
        return getClickToPayErrorResponse(unbindAppInstanceResponse.error, undefined, unbindAppInstanceErrorMessage);
      }
      logger.setLogInfo("SIGNOUT | SUCCESS | Customer signed out successfully from Click to Pay.", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
      var customerSignedOut = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
              "recognized",
              false
            ]]);
      maskedCards.contents = [];
      return customerSignedOut;
    }
    catch (raw_err){
      var err$1 = Caml_js_exceptions.internalToOCamlException(raw_err);
      logger.setLogError("SIGNOUT | Failed to sign out Customer " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err$1)), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
      return Utils$OrcaPaymentPage.getFailedSubmitResponse("ERROR", unbindAppInstanceErrorMessage);
    }
  };
  return await new Promise((function (resolve, param) {
                if (ctpToken !== undefined) {
                  customerEmail.contents = ctpToken.email;
                  var getSessionObject = function (visaDirectSdk) {
                    return {
                            isCustomerPresent: (function (isCustomerPresentInput) {
                                var email = Core__Option.flatMap(isCustomerPresentInput, (function (customerInput) {
                                        return customerInput.email;
                                      }));
                                return isCustomerPresent(visaDirectSdk, email);
                              }),
                            getUserType: (function () {
                                return getUserType();
                              }),
                            getRecognizedCards: (function () {
                                return getRecognizedCards();
                              }),
                            validateCustomerAuthentication: (function (otpValue) {
                                return validateCustomerAuthentication(otpValue);
                              }),
                            checkoutWithCard: (function (checkoutWithCardInput) {
                                return checkoutWithCard(ctpToken, checkoutWithCardInput.srcDigitalCardId, checkoutWithCardInput.rememberMe, checkoutWithCardInput.windowRef);
                              }),
                            signOut: (function () {
                                return signOut();
                              })
                          };
                  };
                  if (shouldLoadScripts) {
                    logger.setLogInfo("C2P | INIT", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                    return ClickToPayHelpers$OrcaPaymentPage.loadVisaScript(ctpToken, (function () {
                                  var initConfig = ClickToPayHelpers$OrcaPaymentPage.getVisaInitConfig(ctpToken, clientSecret);
                                  Core__Promise.$$catch(window.VSDK.initialize(initConfig).then(async function (param) {
                                            var mastercardDirectInitData_srcInitiatorId = isProductionEnv ? "78fbc211-73e1-4c3a-bc5c-60a7921afb97" : "544ef81a-dae0-4f26-9511-bfbdba3d62b5";
                                            var mastercardDirectInitData_srciDpaId = isProductionEnv ? "d693c074-8945-4ec7-aa7d-a0a85e636a62" : "b6e06cc6-3018-4c4c-bbf5-9fb232615090";
                                            var mastercardDirectInitData_dpaTransactionOptions = {
                                              dpaLocale: ctpToken.locale
                                            };
                                            var mastercardDirectInitData = {
                                              srciTransactionId: clientSecret,
                                              srcInitiatorId: mastercardDirectInitData_srcInitiatorId,
                                              srciDpaId: mastercardDirectInitData_srciDpaId,
                                              dpaTransactionOptions: mastercardDirectInitData_dpaTransactionOptions
                                            };
                                            var visaDirectSdk = new window.vAdapters.VisaSRCI();
                                            var visaDirectInitData_srcInitiatorId = ctpToken.dpaId;
                                            var visaDirectInitData_srciDpaId = ctpToken.dpaName;
                                            var visaDirectInitData = {
                                              srciTransactionId: clientSecret,
                                              srcInitiatorId: visaDirectInitData_srcInitiatorId,
                                              srciDpaId: visaDirectInitData_srciDpaId
                                            };
                                            var mastercardInitPromise = window.SRCSDK_MASTERCARD.init(mastercardDirectInitData);
                                            var visaInitPromise = visaDirectSdk.init(visaDirectInitData);
                                            var promiseResults = await Promise.allSettled([
                                                  mastercardInitPromise,
                                                  visaInitPromise
                                                ]);
                                            if (promiseResults.length === 2) {
                                              var mastercardPromiseResponse = promiseResults[0];
                                              var visaPromiseResponse = promiseResults[1];
                                              if (mastercardPromiseResponse.status === "fulfilled") {
                                                logger.setLogInfo("C2P | INIT_MASTER_DIRECT | Loaded", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                                              } else {
                                                logger.setLogError("C2P | INIT_MASTER_DIRECT | Direct Mastercard Click to Pay SDK initialization failed " + JSON.stringify(Utils$OrcaPaymentPage.formatException(mastercardPromiseResponse.reason)), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                                              }
                                              if (visaPromiseResponse.status === "fulfilled") {
                                                logger.setLogInfo("C2P | INIT_VISA_DIRECT | Loaded", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                                              } else {
                                                logger.setLogError("C2P | INIT_VISA_DIRECT | Direct Visa Click to Pay SDK initialization failed " + JSON.stringify(Utils$OrcaPaymentPage.formatException(visaPromiseResponse.reason)), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                                              }
                                            }
                                            window.initializedVSDK = true;
                                            window.visaDirectSdk = visaDirectSdk;
                                            resolve(getSessionObject(visaDirectSdk));
                                            return null;
                                          }), (function (param) {
                                          logger.setLogError("C2P | INIT | Failed to load Click to Pay script and init VSDK.", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                                          var failedErrorResponse = Utils$OrcaPaymentPage.getFailedSubmitResponse("ERROR", "An unknown error occurred while initializing Click to Pay session.");
                                          resolve(failedErrorResponse);
                                          return Promise.resolve(null);
                                        }));
                                }), (function () {
                                  logger.setLogError("C2P | INIT | Failed to load Click to Pay script.", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                                  var failedErrorResponse = Utils$OrcaPaymentPage.getFailedSubmitResponse("ERROR", "Failed to load Click to Pay script.");
                                  resolve(failedErrorResponse);
                                }));
                  }
                  var match = window.initializedVSDK;
                  if (!(match == null) && match) {
                    logger.setLogInfo("C2P | SESSION | FOUND", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                    return resolve(getSessionObject(Caml_option.nullable_to_opt(window.visaDirectSdk)));
                  }
                  logger.setLogInfo("C2P | SESSION | NOT_FOUND", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                  var failedErrorResponse = Utils$OrcaPaymentPage.getFailedSubmitResponse("SESSION_NOT_FOUND", "No Active Click to Pay session found.");
                  return resolve(failedErrorResponse);
                }
                logger.setLogError("C2P | INIT | An error occured while trying to fetch Click to Pay Details", "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                var failedErrorResponse$1 = Utils$OrcaPaymentPage.getFailedSubmitResponse("ERROR", "An error occured while trying to fetch Click to Pay Details");
                resolve(failedErrorResponse$1);
              }));
}

async function getActiveClickToPaySession(clientSecret, publishableKey, logger, customPodUri, endpoint, profileId, authenticationId, merchantId) {
  return await initClickToPaySession(clientSecret, publishableKey, logger, customPodUri, endpoint, profileId, authenticationId, merchantId, {
              request3DSAuthentication: undefined
            }, false);
}

window.ClickToPayAuthenticationSession = initClickToPaySession;

export {
  clickToPayTokenCache ,
  setClickToPayTokenWithDebounce ,
  initClickToPaySession ,
  getActiveClickToPaySession ,
}
/*  Not a pure module */
